import style from './Center.module.scss';

import { EntryTypeStatus, Nullable, Optional } from 'chaika-frontend-types/frontend-cms';

import { translate } from '@chaika/i18n/helper';

import { useEntryTypeDraft } from '../../hooks/useEntryTypeDraft';

export interface CenterParams {
    entryTypeId: string;
    version: number;
}

export function Center({ entryTypeId, version }: CenterParams) {
    const { entryType } = useEntryTypeDraft({ entryTypeId, version });

    return (
        <div className={style.root}>
            <div className={style.title}>{entryType?.title}</div>
            <div className={style.status}>{getStatusTitle(entryType?.status)}</div>
        </div>
    );
}

function getStatusTitle(status: Optional<Nullable<EntryTypeStatus>>): string {
    switch (status) {
        case EntryTypeStatus.Active:
            return translate('activeMasculine');
        case EntryTypeStatus.Draft:
            return translate('draft');
        case EntryTypeStatus.Archived:
            return translate('archive');
        default:
            return '';
    }
}
